module.exports = __webpack_public_path__ + "img/about.e426dda7.png";